import { render, staticRenderFns } from "./addusercomponents.vue?vue&type=template&id=c8012c7a"
import script from "./addusercomponents.vue?vue&type=script&lang=js"
export * from "./addusercomponents.vue?vue&type=script&lang=js"
import style0 from "./addusercomponents.vue?vue&type=style&index=0&id=c8012c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports